'use strict';

const _ = require('lodash');

function SettingsController (
    $http,
    $rootScope,
    $scope,
    $state,
    $window,
    $timeout,
    AnalyticsService,
    IdentityService,
    invitations,
    OrganizationStore,
    PlanStore,
    SettingsActions,
    AppDialogsActions,
    SettingsService,
    SettingsStore,
    ManagerStore,
    IntercomService,
    IngestorService,
    DropdownService
) {
  const vm = this;
  const basePaymentsUrl = `${IdentityService.getPaymentsApiUri()}subscriptions`;

  vm.loading = false;
  vm.ASSETS_DOMAIN = $rootScope.CONST.assets_domain;
  vm.hasMultipleOrganizations = SettingsService.hasMultipleOrganizations;
  vm.numRequests = invitations.length || '';
  vm.showNav = false;
  vm.visible = false;
  vm.pricingPage = SettingsService.PRICING_PAGE;
  vm.newSeats = 1;
  vm.couponCode = '';
  vm.org = null;
  vm.plan = null;
  vm.externalPlan = null;
  vm.externalCustomer = null;
  vm.subscription = null;
  vm.addons = null;
  vm.loading = false; // for buttons
  vm.showSpinner = false; // for icon spinner / loading bar
  /** Set User Permissions **/
  vm.isOrganizationAdmin = IdentityService.isOrganizationAdmin();
  vm.isBetaUser = IdentityService.isBetaUser();
  vm.isIngestorUser = IdentityService.isIngestBetaUser();
  vm.hasEnabledPlan = PlanStore.get('orgPlan') && PlanStore.get('orgPlan').isEnabled;
  /* custom logo */
  this.brandConfig = OrganizationStore.getBrandConfig();
  /* /custom logo */

  vm.handleShowReactivated = () => {
    vm.showSpinner = false;

    SettingsService.growl(SettingsService.generateGrowlData('activated!', 'handleShowReactivated'));
  };

  vm.handleShowCancelled = () => {
    vm.showSpinner = false;

    SettingsService.growl(SettingsService.generateGrowlData('cancelled.', 'handleShowCancelled'));
  };

  vm.handleShowUpdated = () => {
    vm.showSpinner = false;

    SettingsService.growl(SettingsService.generateGrowlData('updated!', 'handleShowUpdated'));
  };

  vm.handleShowError = () => {
    vm.showSpinner = false;

    const growlData = SettingsService.generateGrowlData('error', 'handleShowError');
    growlData.message = 'An error has occurred!';
    growlData.type = 'warning';

    SettingsService.growl(growlData);
  };

  vm.handleSetOrgPlan = () => {
    vm.showSpinner = false;
    vm.org = OrganizationStore.get('current');
    vm.plan = PlanStore.get('orgPlan');
    vm.externalPlan = PlanStore.get('externalPlan');
    vm.externalCustomer = PlanStore.get('externalCustomer');
    vm.subscription = PlanStore.get('externalSubscription');
    vm.addons = PlanStore.get('externalPlanAddons');

    if (vm.subscription) {
      if (vm.subscription.status === 'in_trial' && vm.externalCustomer.card_status !== 'valid') {
        vm.planUpsellState = true;
        vm.daysLeft = (new Date(vm.subscription.trial_end) - new Date() / 1000 ) / (60 * 60 * 24);
        if (vm.daysLeft <= 5) {
          // Show growler once growlers can be published to specific containers
        }
      }
      else if (vm.subscription.status === 'cancelled') {
        vm.daysLeft = 0;
        vm.planUpsellState = true;
      }
      else {
        vm.planUpsellState = false;
      }
    }

    vm.hasEnabledPlan = PlanStore.get('orgPlan').isEnabled
    IngestorService.sendHideTopbarWidget()
    IngestorService.sendShowTopbarWidget()
    vm.canPlanChat = PlanStore.get('orgPlan').isEnabled && PlanStore.checkFeature('organization', 'chat_support');
  };

  vm.convertToSubscription = () => {
    window.open('https://www.skycatch.com/pricing/#contact_form', '_blank')
    // vm.subscription = PlanStore.get('externalSubscription');
    // AnalyticsService.track('[CORE] Subscription', 'Enter Flow', {
    //   'remaining_days': (new Date(vm.subscription.trial_end) - new Date() / 1000) / (60 * 60 * 24),
    //   'state': $state.current.name
    // });
    // AppDialogsActions.GetSelectPlanPage.dispatch();
  };

  /** Sidebar Methods **/
  vm.toggleSidebar = () => {
    vm.showNav = !vm.showNav;
  };

  vm.closeSidebar = () => {
    vm.showNav = false;
  };

  /** Header Methods **/
  vm.returnHome = () => {
    vm.loading = true;

    $state.go('dash.map');
  };

  vm.openSupport = () => {
    $window.open(SettingsService.SUPPORT_LINK, '_blank');
  };

  vm.changeOrg = () => {
    $state.go('select-organization');
  };

  vm.logout = () => {
    $state.go('logout', {}, {
      location: false
    });
  };

  /** Dialog Methods **/
  vm.openDialog = () => {
    vm.sites = OrganizationStore.get('projects');
    vm.selected = [];
    vm.user = SettingsStore.get('user');
    vm.action = SettingsStore.get('action');
    vm.message = SettingsStore.get('message');
    vm.selectedPlan = SettingsStore.get('plan');
    vm.view = SettingsStore.get('view');
    vm.visible = true;
  };

  vm.hideDialog = () => {
    vm.visible = false;
  };

  vm.addMember = () => {
    const projects = [];
    const org = OrganizationStore.get('current');
    const currentUser = SettingsService.currentUser;

    _.forEach(vm.selected, (selection) => {
      projects.push(selection.id);
    });

    vm.newUser.fromUserId = currentUser.id;
    vm.newUser.fromName = [currentUser.firstName, currentUser.lastName].join(' ');
    vm.newUser.orgName = org.name;
    vm.newUser.organizationId = org.id;
    vm.newUser.projectId = projects.toString();
    vm.newUser.planId = _.find(org.plans, (plan) => { // this case should not exist [Bad Data]
      return plan.organizationId === org.id;
    }).id;

    AnalyticsService.track('[CORE] Invitations', 'Add Member to Organization', {
      organization: org.name,
      projects: projects,
      addedBy: currentUser.id,
      newMemberName: [vm.newUser.firstName, vm.newUser.lastName].join(' '),
      organizationId: org.id
    });

    SettingsActions.AddMember.dispatch(vm.newUser);
  };

  vm.handleInvitationSuccessOrError = () => {
    vm.view = SettingsStore.get('view');
  };

  vm.addAnotherUser = () => {
    vm.newUser = {};
    vm.newUserForm.$setPristine();
    SettingsActions.AddAnotherUser.dispatch();
  };

  /** Request Handling **/
  vm.requestHandled = () => {
    if (vm.numRequests === 1) {
      vm.numRequests = '';
    }
    else {
      --vm.numRequests;
    }
  };

  vm.refresh = () => {
    location.reload();
  };

  vm.selectedNewPlan = (planId) => {
    const url = `${IdentityService.getPaymentsApiUri()}plans/${planId}`; // name => plan id in Chargebee
    const httpConfig = { url, method: 'GET' };

    return $http(httpConfig)
    .then((payload) => {
      SettingsActions.OpenDialog.dispatch('confirmChangePlan', {'plan': payload.data.plan});
    });
  };

  vm.reactivateSubscription = (targetPlan, command) => {
    // Attempt to reactive the cancelled subscription, or if in trial - activate right now
    vm.loading = true;
    const url = (command === 'in_trial') ? `${basePaymentsUrl}/update` : `${basePaymentsUrl}/reactivate`;
    const data = {
      organization: OrganizationStore.get('current').id,
      plan: PlanStore.get('orgPlan').id,
      targetPlan: targetPlan || '',
      command: command === 'in_trial' ? 'activate' : ''
    };
    const httpConfig = { url, method: 'POST', data };

    return $http(httpConfig)
    .then(() => {
      vm.showSpinner = true;
      vm.loading = false;

      AnalyticsService.track('[CORE] Billing', 'Subscription Activated Explicitly', data);

      return SettingsActions.OpenDialog.dispatch('reactivateSubscriptionSuccess', {});
    })
    .catch((err) => {
      vm.showSpinner = false;
      vm.loading = false;

      return SettingsActions.OpenDialog.dispatch('genericFailure', {'message': err.data.error.friendlyMessage});
    });
  };

  vm.changePlan = () => {
    SettingsActions.OpenDialog.dispatch('changePlan', {});
  };

  vm.doSubmitCoupon = () => {
    vm.loading = true;
    const url = `${basePaymentsUrl}/update`;
    const data = {
      organization: OrganizationStore.get('current').id,
      plan: PlanStore.get('orgPlan').id,
      coupon: vm.couponCode
    };
    const httpConfig = { url, method: 'POST', data };

    return $http(httpConfig)
    .then(() => {
      vm.showSpinner = true;
      vm.loading = false;
      AnalyticsService.track('[CORE] Billing', 'Coupon Code Applied', {
        planId: PlanStore.get('orgPlan').id,
        orgId: OrganizationStore.get('current').id,
        code: vm.couponCode
      });

      return SettingsActions.OpenDialog.dispatch('inputCouponSuccess', {});
    })
    .catch((err) => {
      vm.showSpinner = false;
      vm.loading = false;
      AnalyticsService.track('[CORE] Billing', 'Coupon Code Failed', {
        planId: PlanStore.get('orgPlan').id,
        orgId: OrganizationStore.get('current').id,
        code: vm.couponCode
      });

      return SettingsActions.OpenDialog.dispatch('genericFailure', { 'message': err.data.error.friendlyMessage });
    });
  };

  vm.doChangeSeats = () => {
    if (PlanStore.get('externalSubscription').status !== 'in_trial') {
      vm.loading = true;
      const url = `${basePaymentsUrl}/update`;
      const data = {
        organization: OrganizationStore.get('current').id,
        plan: PlanStore.get('orgPlan').id,
        addons: [{
          type: 'seats',
          quantity: (vm.action === 'Remove') ? -vm.newSeats : vm.newSeats
        }]
      };
      const httpConfig = { url, method: 'POST', data };

      return $http(httpConfig)
      .then(() => {
        AnalyticsService.track('[CORE] Billing', 'Change User Seats', {
          planId: PlanStore.get('orgPlan').id,
          orgId: OrganizationStore.get('current').id,
          quantity: vm.newSeats
        });
        vm.showSpinner = true;
        vm.loading = false;

        return SettingsActions.OpenDialog.dispatch('changeUserSeatsSuccess', {});
      })
      .catch((err) => {
        vm.showSpinner = false;
        vm.loading = false;

        return SettingsActions.OpenDialog.dispatch('genericFailure', { 'message': err.data.error.friendlyMessage });
      });
    }
    else {
      SettingsActions.OpenDialog.dispatch('genericFailure', { 'message': 'This functionality is not supported in trial accounts!' });
    }
  };

  vm.showAddUserSeatsDialog = () => {
    SettingsActions.OpenDialog.dispatch('changeUserSeats', { plan: PlanStore.get('orgPlan'), action: 'Add' });
  };

  vm.openChat = () => {
    IntercomService.show();
    DropdownService._closeGroup('topnav')
  };

  vm.trackBillingAction = () => {
    AnalyticsService.track('[CORE] Subscription', 'Open billing settings', { });
  };

  this.handleSetOrgPlan();
  vm.canPlanChat = PlanStore.get('orgPlan').isEnabled && PlanStore.checkFeature('organization', 'chat_support');
  ManagerStore.syncSubscribe();
  $timeout(() => {
    IngestorService.sendHideTopbarWidget()
    IngestorService.sendShowTopbarWidget()
  }, 500)

  /** Register Flux action listeners **/
  SettingsStore.on(SettingsStore.Events.OpenDialog, this.openDialog.bind(this), $scope);
  SettingsStore.on(SettingsStore.Events.RequestHandled, this.requestHandled.bind(this), $scope);
  SettingsStore.on(SettingsStore.Events.InvitationSuccess, this.handleInvitationSuccessOrError.bind(this), $scope);
  SettingsStore.on(SettingsStore.Events.InvitationError, this.handleInvitationSuccessOrError.bind(this), $scope);
  PlanStore.on(PlanStore.Events.Changed, this.handleSetOrgPlan.bind(this), $scope);
  PlanStore.on(PlanStore.Events.Cancelled, this.handleShowCancelled.bind(this), $scope);
  PlanStore.on(PlanStore.Events.Reactivated, this.handleShowReactivated.bind(this), $scope);
  PlanStore.on(PlanStore.Events.Updated, this.handleShowUpdated.bind(this), $scope);
  PlanStore.on(PlanStore.Events.Error, this.handleShowError.bind(this), $scope);
}

SettingsController.$inject = [
  '$http',
  '$rootScope',
  '$scope',
  '$state',
  '$window',
  '$timeout',
  'AnalyticsService',
  'IdentityService',
  'invitations',
  'OrganizationStore',
  'PlanStore',
  'SettingsActions',
  'AppDialogsActions',
  'SettingsService',
  'SettingsStore',
  'ManagerStore',
  'IntercomService',
  'IngestorService',
  'DropdownService'
];

module.exports = SettingsController;



// WEBPACK FOOTER //
// ./src/app/settings/SettingsController.js